import { Event } from '@/event-bus/event';

export class ColumnSavingTriggeredEvent extends Event<void> {}
